import { captureException } from '@sentry/react'
import { createFileRoute, redirect } from '@tanstack/react-router'
import { z } from 'zod'

import { currentPromotionInitiativeId } from '@/state/configuration/currentPromotionInitiativeId'

const SearchParamsZod = z.object({
  central_id: z.number().optional(),
})

export const Route = createFileRoute('/promotions/')({
  validateSearch: SearchParamsZod,
  beforeLoad: async ({ search }) => {
    const initiativeId = await currentPromotionInitiativeId()
    if (!initiativeId) {
      throw new Error('No initiativeId found')
    }
    throw redirect({ to: '/promotions/$initiativeId', params: { initiativeId }, search, replace: true })
  },
  onCatch: (error) => {
    captureException(error, { tags: { route: Route.fullPath } })
  },
})
